import { jwtDecode } from 'jwt-decode';  // Correct way to import jwt-decode

// Utility function to check if a JWT token is expired
export function isTokenExpired(token) {
  if (!token) return true; // No token means expired or invalid

  try {
    const decoded = jwtDecode(token);  // Correctly using jwt-decode with the token
    const currentTime = Date.now() / 1000; // Current time in seconds
    return decoded.exp < currentTime; // Check if token is expired
  } catch (error) {
    return true; // If decoding fails, assume token is invalid/expired
  }
}

// Function to clear a specific cookie
export function clearCookie(cookieName) {
  document.cookie = `${cookieName}=; Max-Age=-1; path=/;`; // Clear the cookie by setting Max-Age to -1
}
